import React from 'react';
import { TextField } from '@mui/material';

const TextFieldWrapper = ({ field, value, onChange, error }) => {
  return (
    <TextField
      fullWidth
      name={field.name}
      label={field.label}
      value={value}
      onChange={(e) => onChange(field.name, e.target.value)}
      error={!!error}
      helperText={error || ''}
      margin="normal"
      type={field.type}
      multiline={field.type === 'textarea'}
      rows={field.type === 'textarea' ? 4 : undefined}
    />
  );
};

export default TextFieldWrapper;
